import { UboGround, UboOwnershipRange } from 'generated/gql';
import { t } from '@lingui/macro';

const uboGroundLabels = {
  [UboGround.Control]: () => t`Zeggenschap`,
  [UboGround.Director]: () => t`Bestuurder (pseudo-UBO)`,
  [UboGround.Economic]: () => t`Economisch belang`,
  [UboGround.Ownership]: () => t`Eigendom`,
  [UboGround.Voting]: () => t`Stemrecht`,
};

export const formatUboGround = (ground: UboGround) => uboGroundLabels[ground]();

const uboOwnershipRangeLabels = {
  [UboOwnershipRange.Range_25_50]: () => t`>25% - 50%`,
  [UboOwnershipRange.Range_51_75]: () => t`>51% - 75%`,
  [UboOwnershipRange.Range_76_100]: () => t`>76% - 100%`,
};

export const formatUboOwnershipRange = (ownershipRange: UboOwnershipRange) =>
  uboOwnershipRangeLabels[ownershipRange]();
